import { Standart } from './Standart'
import { InputField} from './Standart'
import { CustomInputField} from './Standart'

export const Input = { Standart, InputField, CustomInputField}
